/**
 * 통합 마커 컴포넌트
 * 카카오맵 또는 Leaflet 마커를 자동으로 선택
 */

import { ReactNode } from "react";
import { MapMarker as KakaoMapMarker } from "react-kakao-maps-sdk";
import { LeafletMarker } from "./LeafletMapWrapper";
import { useCurrentMapProvider } from "./MapProviderContext";

export interface UnifiedMarkerProps {
  position: { lat: number; lng: number };
  image?: {
    src: string;
    size: { width: number; height: number };
    options?: {
      offset?: { x: number; y: number };
    };
  };
  clickable?: boolean;
  onClick?: () => void;
  title?: string;
  children?: ReactNode;
  zIndex?: number;
}

/**
 * 통합 마커 컴포넌트
 */
export const UnifiedMarker: React.FC<UnifiedMarkerProps> = ({
  position,
  image,
  clickable = true,
  onClick,
  title,
  children,
  zIndex,
}) => {
  const mapProvider = useCurrentMapProvider();

  if (mapProvider === "osm") {
    // Leaflet 마커
    return (
      <LeafletMarker
        position={position}
        icon={image?.src}
        iconSize={image?.size}
        iconAnchor={image?.options?.offset}
        onClick={onClick}
        zIndex={zIndex}
      >
        {children}
      </LeafletMarker>
    );
  }

  // 카카오맵 마커
  return (
    <KakaoMapMarker
      position={position}
      image={image}
      clickable={clickable}
      onClick={onClick}
      title={title}
      zIndex={zIndex}
    >
      {children}
    </KakaoMapMarker>
  );
};

